document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-az-size-guide]');
  if (!root) return;
  const node = root.querySelector('[data-size-products-json]');
  if (!node) return;

  let payload;
  try { payload = JSON.parse(node.textContent); } catch (e) { return; }
  const products = Array.isArray(payload.products) ? payload.products : [];
  const select = root.querySelector('[data-size-product]');
  const empty = root.querySelector('[data-size-empty]');
  const content = root.querySelector('[data-size-content]');
  const missing = root.querySelector('[data-size-missing]');

  const title = root.querySelector('[data-size-product-title]');
  const image = root.querySelector('[data-size-product-image]');
  const fit = root.querySelector('[data-size-fit]');
  const length = root.querySelector('[data-size-length]');
  const sizes = root.querySelector('[data-size-sizes]');
  const note = root.querySelector('[data-size-note]');
  const modelCard = root.querySelector('[data-size-model-card]');
  const modelImageWrap = root.querySelector('[data-size-model-image-wrap]');
  const modelImage = root.querySelector('[data-size-model-image]');
  const modelHeight = root.querySelector('[data-size-model-height]');
  const modelWorn = root.querySelector('[data-size-model-worn]');
  const modelIntro = root.querySelector('[data-size-model-intro]');

  const clean = value => String(value ?? '').trim();

  function render() {
    const product = products.find(p => p.handle === select.value);
    content.hidden = true;
    missing.hidden = true;
    empty.hidden = Boolean(product);
    if (!product) return;

    const hasFitInfo = clean(product.fit) || clean(product.length) || clean(product.note);
    const hasModelInfo = clean(product.modelImage) || clean(product.modelHeight) || clean(product.modelWorn) || clean(product.modelText);

    if (!hasFitInfo && !hasModelInfo) {
      missing.hidden = false;
      return;
    }

    title.textContent = product.title || '';
    image.src = product.image || '';
    image.alt = product.title || 'Produit';
    fit.textContent = clean(product.fit) || 'Non précisée';
    length.textContent = clean(product.length) || 'Non précisée';
    sizes.textContent = Array.isArray(product.sizes) && product.sizes.length ? product.sizes.join(' · ') : 'Voir la fiche produit';
    note.textContent = clean(product.note);
    note.hidden = !clean(product.note);

    modelCard.hidden = !hasModelInfo;
    if (hasModelInfo) {
      if (clean(product.modelImage)) {
        modelImage.src = product.modelImage;
        modelImageWrap.hidden = false;
      } else {
        modelImage.removeAttribute('src');
        modelImageWrap.hidden = true;
      }
      modelHeight.textContent = clean(product.modelHeight) || '—';
      modelWorn.textContent = clean(product.modelWorn) || '—';
      modelIntro.textContent = clean(product.modelText);
      modelIntro.hidden = !clean(product.modelText);
    }

    content.hidden = false;
  }

  select.addEventListener('change', render);
});